var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCellular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.43262,16.48682a11.09045,11.09045,0,0,0,0,15.02636l1.09375-1.02636a9.59111,9.59111,0,0,1,0-12.97364Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.92578,12.97314a15.75286,15.75286,0,0,0,0,22.05372l1.06836-1.05372a14.25088,14.25088,0,0,1,0-19.94628Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.32324,38.53271l1.05664-1.06542a18.92256,18.92256,0,0,1,0-26.93458L15.32324,9.46729a20.42435,20.42435,0,0,0,0,29.06542Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.56738,31.51318a11.09045,11.09045,0,0,0,0-15.02636l-1.09375,1.02636a9.59111,9.59111,0,0,1,0,12.97364Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.07422,35.02686a15.75286,15.75286,0,0,0,0-22.05372l-1.06836,1.05372a14.25088,14.25088,0,0,1,0,19.94628Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.67676,9.46729l-1.05664,1.06542a18.92256,18.92256,0,0,1,0,26.93458l1.05664,1.06542a20.42435,20.42435,0,0,0,0-29.06542Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75,32V16h-1.5v9.25h-2.5V14a.7502.7502,0,0,0-.75-.75H38a.7502.7502,0,0,0-.75.75V25.25h-2.5V16h-1.5V32h1.5V26.75h2.5V34a.7502.7502,0,0,0,.75.75h1.25v6.5H38a.7502.7502,0,0,0-.75.75V70a.7502.7502,0,0,0,.75.75h4a.7502.7502,0,0,0,.75-.75V42a.7502.7502,0,0,0-.75-.75H40.75v-6.5H42a.7502.7502,0,0,0,.75-.75V26.75h2.5V32Zm-5.5,37.25h-2.5V52.75h2.5Zm0-26.5v8.5h-2.5v-8.5Zm0-9.5h-2.5V14.75h2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCellular);
export default __webpack_public_path__ + "static/media/icon_cellular.cefe8297b37fb025e52caf65f5054027.svg";
export { ForwardRef as ReactComponent };